var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 17,
    viewBox: "0 0 29 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7691 0H8.20518C3.69368 0 0 3.71157 0 8.24994C0 12.786 3.69143 16.4999 8.20518 16.4999H20.7691C25.2806 16.4999 28.9743 12.7883 28.9743 8.24994C28.9743 3.71157 25.2828 0 20.7691 0ZM25.0334 8.23638C25.0334 10.5948 23.1147 12.524 20.7691 12.524H8.20293C5.85731 12.524 3.93858 10.5948 3.93858 8.23638C3.93858 5.87796 5.85731 3.94877 8.20293 3.94877H20.7691C23.1147 3.94877 25.0334 5.87796 25.0334 8.23638Z",
    fill: "url(#paint0_linear_6210_290073)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20331 10.8056C9.6154 10.8056 10.7601 9.65461 10.7601 8.23482C10.7601 6.81503 9.6154 5.66406 8.20331 5.66406C6.79121 5.66406 5.64648 6.81503 5.64648 8.23482C5.64648 9.65461 6.79121 10.8056 8.20331 10.8056Z",
    fill: "url(#paint1_linear_6210_290073)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6210_290073",
    x1: 0,
    y1: 8.24993,
    x2: 28.9743,
    y2: 8.24993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5451F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5AA04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6210_290073",
    x1: 5.64648,
    y1: 8.23482,
    x2: 10.7601,
    y2: 8.23482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5451F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5AA04"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColor);
export default __webpack_public_path__ + "static/media/logo-color.9208f878f9ec5611370f62f465a5bcb6.svg";
export { ForwardRef as ReactComponent };